module.exports = __webpack_public_path__ + "images/cacb75a98d7c9baa112a792d6231621c-glas.jpg";